import script from "./MaxioCompanySubscription.vue?vue&type=script&setup=true&lang=js"
export * from "./MaxioCompanySubscription.vue?vue&type=script&setup=true&lang=js"

import "./MaxioCompanySubscription.vue?vue&type=style&index=0&id=350ae9ea&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350ae9ea"]])

export default __exports__